module.exports = __webpack_public_path__ + "img/Clipperton Island.03d6578b.svg";